module.exports = __webpack_public_path__ + "static/media/mpl-logo.05d4d81e.png";